import { CommonModule, KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbDropdownModule, NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { Client, ClientApplication } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';

@Component({
  selector: 'app-form-client-app-settings',
  templateUrl: './form-client-app-settings.component.html',
  styleUrls: ['./form-client-app-settings.component.scss'],
  standalone: true,
  imports: [TranslateModule, CommonModule, ReactiveFormsModule, NgbModalModule, NgbDropdownModule],
  providers: [NgbModal, TranslationService]
})
export class FormClientAppSettingsComponent implements OnInit {

  @Input() type?: string;
  @Input() application?: ClientApplication;
  @Input() client?: Client;

  @Output() deleteApp = new EventEmitter<ClientApplication>();
  @Output() deleteClient = new EventEmitter<Client>();
  @Output() addApp = new EventEmitter<ClientApplication>();
  @Output() addClient = new EventEmitter<Client>();

  lappclient: ClientApplication[] = [];
  mapClient = new Map<string, ClientApplication[]>();
  form: FormGroup | null = null;

  /** For now only these 2 OS */
  readonly formOSChoices = ['android', 'ios'];

  constructor(private readonly modalService: NgbModal) {}

  ngOnInit(): void {
    if (this.client && !this.application) {
      this.getClientAppFromOs();
    }
  }

  getFormControl(champ: string): FormControl {
    return this.form?.get(champ) as FormControl;
  }

  /**
   * Initializes the modal and form according to the @Input attributes.
   */
  async open({ content }: { content: any }) {
    this.modalService.open(content, { centered: true });
    if (this.client && this.type === 'add-app') {
      this.lappclient = await Backend.POLICIES.getApplicationClient(this.client);
      const lappclientnames = this.lappclient.map(val => val.packageName + val.os);
      this.form = new FormGroup({
        packageName: new FormControl('', [Validators.required, Backend.SETTINGS.noWhitespaceValidator()]),
        os: new FormControl(this.formOSChoices[0], Validators.required)
      }, {
        validators: Backend.SETTINGS.checkMultifield('packageName', 'os', lappclientnames)
      });
    } else {
      const clients = await Backend.POLICIES.getClients();
      const clientnames = clients.map(c => c.name);
      if (this.type === 'add-client') {
        this.form = new FormGroup({
          name: new FormControl('', [
            Validators.required,
            Backend.SETTINGS.noWhitespaceValidator(),
            Backend.SETTINGS.notExistValidator(clientnames)
          ])
        });
      }
    }
  }

  async getClientAppFromOs() {
    if (this.client) {
      this.mapClient = new Map();
      this.lappclient = await Backend.POLICIES.getApplicationClient(this.client);
      for (const os of Backend.POLICIES.getAllOsClientApplications(this.lappclient)) {
        this.mapClient.set(os, Backend.POLICIES.getAppClientByOS(os, this.lappclient));
      }
    }
  }

  /**
   * Preserve the original order for use as a pipe.
   */
  originalOrder = (
    a: KeyValue<string, ClientApplication[]>,
    b: KeyValue<string, ClientApplication[]>
  ): number => 0;

  setOs(os: string) {
    this.form?.patchValue({ os });
  }

  emitAddClient() {
    if (this.form) {
      this.addClient.emit({ name: this.getFormControl('name').value });
    }
  }

  emitAddAppli() {
    if (this.form) {
      this.addApp.emit({
        packageName: this.getFormControl('packageName').value,
        os: this.getFormControl('os').value?.toUpperCase()
      });
    }
  }

  emitDelete() {
    if (this.client && !this.application) {
      this.deleteClient.emit(this.client);
    } else if (this.application) {
      this.deleteApp.emit(this.application);
    }
  }
}
